<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb"
      >
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>视频管理</el-breadcrumb-item>
        <el-breadcrumb-item>短视频</el-breadcrumb-item>
        <!--        <el-breadcrumb-item><span style="color: cornflowerblue">{{ thisdataa.title }}</span>的视频</el-breadcrumb-item>-->
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row style="border-bottom: 1px solid #EEEEEE;padding-bottom: 10px;">
          <el-col :span="8">&nbsp;
          </el-col>
          <el-col
            :span="16"
            style="text-align: right"
          >
            <el-switch
              v-model="state"
              @change="changeArticleState1(state)"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
            <el-button
              style="margin-left: 20px"
              type="primary"
              size="small"
              plain
              @click="addshow('')"
            >新增发布</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="dataa"
          align="left"
          style="width: 100%"
        >
          <el-table-column
            prop="title"
            label="标题"
          >
          </el-table-column>
          <el-table-column label="封面地址00">
            <template slot-scope="scope">
              <img
                v-if="scope.row.is_type==1"
                :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.image_url"
                alt=""
                width="60"
                height="60"
              >
              <img
                v-else-if="scope.row.is_type==2"
                :src="'http://api.txcsok.com/'+scope.row.image_url"
                alt=""
                width="60"
                height="60"
              >
            </template>
          </el-table-column>
          <el-table-column
            label="视频"
            prop="introduction"
          >
            <template slot-scope="scope">
              <div>
                <video
                  v-if="scope.row.is_type==1"
                  :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+scope.row.video_url"
                  alt=""
                  controls="controls"
                  width="130"
                  height="78"
                />
                <video
                  v-else-if="scope.row.is_type==2"
                  :src="'http://api.txcsok.com/'+scope.row.video_url"
                  alt=""
                  controls="controls"
                  width="130"
                  height="78"
                />
              </div>
            </template>
          </el-table-column>
          <!--   <el-table-column-->
          <!--            label="介绍"-->
          <!--            prop="introduction"-->
          <!--            width="100">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button type="primary" @click="details(scope.row)" plain >查看</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <el-table-column label="发布时间">
            <template slot-scope="scope">
              {{ formatDate(scope.row.addtime) }}
            </template>
          </el-table-column>
          <el-table-column label="启用">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.state"
                @change="changeArticleState(scope.row.video_id,scope.row.state)"
                :active-value="1"
                :inactive-value="2"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                @click="editvalue(scope.row)"
                size="small"
                type="text"
              >修改
              </el-button>
              <el-button
                @click="changevaluestate(scope.row.video_id,0)"
                size="small"
                type="text"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="位置调整"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <!--              v-if="scope.$index >0"-->
              <el-button
                @click="qian(scope.row.video_id)"
                size="small"
                type="text"
              >
                前移
              </el-button>
              <el-button
                @click="hou(scope.row.video_id)"
                size="small"
                type="text"
              >
                后移
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-row style="margin-top: 20px">

          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            align="right"
          >
            <el-pagination
              style="text-align: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="datatotal"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </el-row>
    </el-row>
    <el-dialog
      title="详情"
      :visible.sync="infoVisible"
      width="360px"
      :modal-append-to-body="false"
    >
      <el-form
        label-position="left"
        class="demo-table-expand"
        label-width="108px"
        style="text-align: left"
      >

        <el-form-item label="视频">
        </el-form-item>
        <div>
          <video
            :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+infodata.video_url"
            alt=""
            controls="controls"
            width="320"
            height="158"
          />
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
    @close="close1"
      title="新增"
      :visible.sync="addVisible"
      width="360px"
      :modal-append-to-body="false"
    >
      <el-form
        :model="adddata"
        :rules="addrules"
        ref="adddata"
        style="text-align: left"
      >
        <el-form-item
          label="标题"
          :label-width="formLabelWidth"
          prop="title"
        >
          <el-input
            clearable
            v-model="adddata.title"
            auto-complete="off"
            placeholder="请输入"
            required
          ></el-input>
        </el-form-item>
        <el-form-item
          label="封面地址"
          :label-width="formLabelWidth"
          prop="title"
        >
          <div class="oss_file">
            <!-- <input type="file" :id="addid1" @change="adddoUpload1" value="" accept="image/*"/> -->
            <el-upload
              class="upload-demo"
              action="http://api.txcsok.com/File/fileUp"
              :file-list="fileList1"
              :on-success="onSuccess1"
              :headers="up_obj"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
            </el-upload>
            <div style="text-align: left">
              <!-- <img v-if="adddata.image_url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+adddata.image_url" alt="" style="max-width: 50px"> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="视频"
          :label-width="formLabelWidth"
          prop="title"
        >
          <div class="oss_file">
            <!-- <input type="file" :id="addid" @change="adddoUpload" value="" accept="video/*"/> -->
            <el-upload
              class="upload-demo"
              action="http://api.txcsok.com/File/fileUp"
              :file-list="fileList2"
              :on-success="onSuccess2"
              :headers="up_obj"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
            </el-upload>
            <div style="text-align: left">
              <!-- <img v-if="adddata.video_url" :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+adddata.video_url" alt="" style="max-width: 50px"> -->
            </div>
            <div>
              <el-progress
                v-if="isShow"
                :status="zt"
                :text-inside="true"
                :stroke-width="18"
                :percentage="percentage"
              ></el-progress>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitadd('adddata')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      @close="close1"
      :visible.sync="editVisible"
      width="360px"
      :modal-append-to-body="false"
    >
      <el-form
        :model="editdata"
        :rules="editrules"
        ref="editdata"
        style="text-align: left"
      >
        <el-form-item
          label="标题"
          :label-width="formLabelWidth"
          prop="title"
        >
          <el-input
            clearable
            v-model="editdata.title"
            auto-complete="off"
            placeholder="请输入"
            required
          ></el-input>
        </el-form-item>
        <!--        <el-form-item label="单价" :label-width="formLabelWidth" prop="price">-->
        <!--          <el-input clearable v-model="editdata.price" auto-complete="off" placeholder="请输入"-->
        <!--                    required></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item
          label="封面地址"
          :label-width="formLabelWidth"
          prop="title"
        >
          <div class="oss_file">
                        <el-upload
              class="upload-demo"
              action="http://api.txcsok.com/File/fileUp"
              :file-list="fileList1"
              :on-success="onSuccess3"
              :headers="up_obj"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
            </el-upload>
            <!-- <input
              type="file"
              :id="editid1"
              @change="editdoUpload1"
              value=""
              accept="image/*"
            /> -->
            <div style="text-align: left">
              <!-- <img
                v-if="editdata.image_url"
                :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+editdata.image_url"
                alt=""
                style="max-width: 50px"
              > -->
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="视频"
          :label-width="formLabelWidth"
          prop="title"
        >
          <div class="oss_file">
            <!-- <input
              type="file"
              :id="editid"
              @change="editdoUpload"
              value=""
              accept="video/*"
            /> -->
                        <el-upload
              class="upload-demo"
              action="http://api.txcsok.com/File/fileUp"
              :file-list="fileList2"
              :on-success="onSuccess4"
              :headers="up_obj"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
            </el-upload>
            <div style="text-align: left">
              <!-- <video
                v-if="editdata.video_url"
                :src="'http://txcsapp.oss-cn-zhangjiakou.aliyuncs.com/'+editdata.video_url"
                alt=""
                style="max-width: 60px"
              /> -->
            </div>
            <div>
              <el-progress
                v-if="isShow"
                :status="zt"
                :text-inside="true"
                :stroke-width="18"
                :percentage="percentage"
              ></el-progress>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitedit('editdata')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>
export default {
  name: "Class",
  mounted() {
    this.up_obj["fs-token"] = this.$store.state.login.user.jwt;
    if (!this.$store.state.login.in) {
      this.$router.push({ name: "login", params: { userId: 123 } });
    }
    console.log(this.thisdataa);

    this.getstart();
  },
  data() {
    return {
      fileList1: [],
      fileList2: [],
      up_obj: {},
      state: 1,
      bucket: "txcsapp",
      region: "oss-cn-zhangjiakou",
      addid: "addupload",
      editid: "editupload",
      addid1: "addupload1",
      editid1: "editupload1",
      thisdataa: [],
      zt: "",
      percentage: 0,
      isShow: false,
      dataa: [],
      pagesize: 10,
      currentPage: 1,
      datatotal: 0,
      defaultProps: {
        children: "children",
        label: "label",
      },
      activeName: "",
      fullscreenLoading: false,
      //表格
      formLabelWidth: "100px",
      addVisible: false,
      editVisible: false,
      infoVisible: false,
      infodata: {},
      adddata: {
        theme_id: "",
        title: "",
        video_url: "",
        image_url: "",
      },
      addrules: {
        title: { required: true, message: "请输入", trigger: "blur" },
        video_url: { required: true, message: "请输入", trigger: "blur" },
        image_url: { required: true, message: "请输入", trigger: "blur" },
      },
      editdata: {
        title: "",
        video_url: "",
        image_url: "",
      },
      editrules: {
        title: { required: true, message: "请输入", trigger: "blur" },
        video_url: { required: true, message: "请输入", trigger: "blur" },
        image_url: { required: true, message: "请输入", trigger: "blur" },
      },
    };
  },
  computed: {
    urll() {
      return (
        "http://wangkeapi.cqxddwl.com/Weixin/index?areauserid=" +
        this.$store.state.login.user.area_user_id
      );
    },
  },
  watch: {
    percentage() {
      if (this.percentage == 100) {
        this.zt = "success";
      }
    },
  },
  methods: {
    close1(){
      this.fileList1 = []
      this.fileList2 = []
    },
    onSuccess1(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      // this.adddata.url = response.data
      this.$set(this.adddata, "image_url", response.data);
    },
    onSuccess2(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      // this.adddata.url = response.data
      this.$set(this.adddata, "video_url", response.data);
    },
    onSuccess3(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      // this.adddata.url = response.data
      this.$set(this.editdata, "image_url", response.data);
    },
    onSuccess4(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      // this.adddata.url = response.data
      this.$set(this.editdata, "video_url", response.data);
    },
    hou(video_id) {
      let thi = this;
      thi.$http
        .post(global.posturl.host + global.posturl.changeVideoOrder, {
          video_id: video_id,
          direction: "后移",
        })
        .then(function (response) {
          console.log(response.data);
          var qcode = response.data.code;
          var qmsg = response.data.msg;
          var qdata = response.data.data;
          if (qcode == 200) {
            thi.getstart();
          } else {
            thi.$message({
              type: "warning",
              message: qmsg,
            });
            thi.fullscreenLoading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    qian(video_id) {
      let thi = this;
      thi.$http
        .post(global.posturl.host + global.posturl.changeVideoOrder, {
          video_id: video_id,
          direction: "前移",
        })
        .then(function (response) {
          console.log(response.data);
          var qcode = response.data.code;
          var qmsg = response.data.msg;
          var qdata = response.data.data;
          if (qcode == 200) {
            thi.getstart();
          } else {
            thi.$message({
              type: "warning",
              message: qmsg,
            });
            thi.fullscreenLoading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addshow() {
      // this.$router.go(0)
      this.adddata = {};
      this.isShow = false;
      this.addVisible = true;
    },
    adddoUpload1() {
      const _this = this;
      const urls = [];
      _this.$http.post("http://api.txcsok.com/File/fileUp").then((result) => {
        const client = new OSS.Wrapper({
          region: _this.region,
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          bucket: _this.bucket,
        });
        _this.percentage = 0;
        const files = document.getElementById(_this.addid1);
        if (files.files) {
          const fileLen = document.getElementById(_this.addid1).files;
          let resultUpload = "";
          for (let i = 0; i < fileLen.length; i++) {
            const file = fileLen[i];
            console.log(file);
            // 随机命名
            let random_name =
              "video/image_url/" +
              new Date().getTime() +
              this.random_string(6) +
              "_" +
              "." +
              file.name.split(".").pop();
            console.log(random_name);
            // 上传
            client
              .multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage * 100);
                },
              })
              .then((results) => {
                // 上传完成
                const url = results.name;
                _this.adddata.image_url = url;
                console.log(url);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      });
    },
    adddoUpload1_hch() {},
    editdoUpload1() {
      const _this = this;
      const urls = [];
      _this.$http.post("http://sts.txcsok.com/oss.php").then((result) => {
        const client = new OSS.Wrapper({
          region: _this.region,
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          bucket: _this.bucket,
        });
        _this.percentage = 0;
        const files = document.getElementById(_this.editid1);
        if (files.files) {
          const fileLen = document.getElementById(_this.editid1).files;
          let resultUpload = "";
          for (let i = 0; i < fileLen.length; i++) {
            const file = fileLen[i];
            console.log(file);
            // 随机命名
            let random_name =
              "video/image_url/" +
              new Date().getTime() +
              this.random_string(6) +
              "_" +
              "." +
              file.name.split(".").pop();
            console.log(random_name);
            // 上传
            client
              .multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage * 100);
                },
              })
              .then((results) => {
                // 上传完成
                const url = results.name;
                _this.editdata.image_url = url;
                console.log(url);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      });
    },
    show() {
      this.isShow = true;
    },
    gohref(name) {
      this.$router.push({ name: name });
    },
    panduanleixing2(type) {
      switch (type) {
        case "1":
          return "";
          break;
        case "2":
          return "success";
          break;
        case "3":
          return "success";
          break;
        default:
          return null;
      }
    },
    details(row) {
      let thi = this;
      thi.infodata = JSON.parse(JSON.stringify(row));
      thi.infoVisible = true;
    },
    //选择展示数量
    handleSizeChange(val) {
      this.pagesize = val;
      this.getstart();
    },
    //跳转页面
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getstart();
    },
    getstart() {
      let thi = this;
      thi.fullscreenLoading = true;
      thi.$http
        .post(global.posturl.host + global.posturl.videoList, {
          theme_id: 1,
          page: thi.currentPage,
          pageSize: thi.pagesize,
        })
        .then(function (response) {
          console.log(response.data);
          var qcode = response.data.code;
          var qmsg = response.data.msg;
          var qdata = response.data.data;
          var qtotal = response.data.Total;
          if (qcode == 200) {
            thi.dataa = qdata;
            thi.datatotal = qtotal;
          }
          thi.fullscreenLoading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleNodeClick(data) {
      console.log(data);
    },
    adddoUpload() {
      const _this = this;
      const urls = [];
      _this.show();
      _this.$http.post("http://sts.txcsok.com/oss.php").then((result) => {
        const client = new OSS.Wrapper({
          region: _this.region,
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          bucket: _this.bucket,
        });

        _this.percentage = 0;

        const files = document.getElementById(_this.addid);
        if (files.files) {
          const fileLen = document.getElementById(_this.addid).files;
          let resultUpload = "";
          for (let i = 0; i < fileLen.length; i++) {
            const file = fileLen[i];
            console.log(file);
            // 随机命名
            var theme_id = _this.thisdataa.theme_id;
            let random_name =
              "video/theme_id/" +
              new Date().getTime() +
              this.random_string(6) +
              "_" +
              "." +
              file.name.split(".").pop();
            console.log(random_name);
            // 上传
            client
              .multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage * 100);
                },
              })
              .then((results) => {
                // 上传完成
                const url = results.name;
                _this.adddata.video_url = url;
                console.log(url);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      });
    },
    editdoUpload() {
      console.log("执行");
      const _this = this;
      const urls = [];
      _this.show();
      _this.$http.post("http://sts.txcsok.com/oss.php").then((result) => {
        const client = new OSS.Wrapper({
          region: _this.region,
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          bucket: _this.bucket,
        });
        _this.percentage = 0;
        const files = document.getElementById(_this.editid);
        if (files.files) {
          const fileLen = document.getElementById(_this.editid).files;
          let resultUpload = "";
          for (let i = 0; i < fileLen.length; i++) {
            const file = fileLen[i];
            console.log(file);
            // 随机命名
            var theme_id = _this.thisdataa.theme_id;
            let random_name =
              "video/" +
              theme_id +
              "/" +
              new Date().getTime() +
              this.random_string(6) +
              "_" +
              "." +
              file.name.split(".").pop();
            console.log(random_name);
            // 上传
            client
              .multipartUpload(random_name, file, {
                progress: function* (percentage, cpt) {
                  // 上传进度
                  _this.percentage = parseInt(percentage * 100);
                },
              })
              .then((results) => {
                // 上传完成
                const url = results.name;
                _this.editdata.video_url = url;
                console.log(url);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      });
    },

    // 随机生成文件名
    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    //提交新增
    submitadd(formName) {
      let thi = this;
      thi.$refs[formName].validate((valid) => {
        if (valid) {
          thi.adddata.theme_id = 1;
          console.log(thi.adddata);
          thi.fullscreenLoading = true;
          thi.$http
            .post(global.posturl.host + global.posturl.videoadd, thi.adddata)
            .then(function (response) {
              console.log(response.data);
              var qcode = response.data.code;
              var qmsg = response.data.msg;
              var qdata = response.data.data;
              if (qcode == 200) {
                thi.gohref("videothemes");
                thi.addVisible = false;
                thi.fullscreenLoading = false;
                thi.getstart();
              } else {
                thi.gohref("videothemes");
                thi.$message({
                  type: "warning",
                  message: qmsg,
                });
                thi.fullscreenLoading = false;
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    //修改
    zzh(row) {
      this.$router.push({ name: "zzh", params: { row } });
    },

    //修改
    editvalue(row) {
      this.editdata = JSON.parse(JSON.stringify(row));
      console.log(this.editdata);
      this.editVisible = true;
    },
    //提交编辑
    submitedit(formName) {
      let thi = this;
      thi.fullscreenLoading = true;
      thi.$http
        .post(global.posturl.host + global.posturl.videoedit, thi.editdata)
        .then(function (response) {
          console.log(response.data);
          var qcode = response.data.code;
          var qmsg = response.data.msg;
          var qdata = response.data.data;
          if (qcode == 200) {
            thi.editVisible = false;
            thi.getstart();
          } else {
            thi.$message({
              type: "warning",
              message: qmsg,
            });
            thi.fullscreenLoading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //删除提示
    changevaluestate(video_id, state) {
      var heeh = "该";
      var caozuo = "禁用";
      if (video_id.length > 1) {
        heeh = "这些";
      }
      if (state == 0) {
        caozuo = "删除";
      }
      let thi = this;
      thi
        .$confirm("此操作将" + caozuo + heeh + "账号, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
        .then(() => {
          thi.submitchangestate(video_id, state);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消" + caozuo,
          });
        });
    },
    //状态改变(删除)
    submitchangestate(video_id, state) {
      let thi = this;
      thi.fullscreenLoading = true;
      this.$http
        .post(global.posturl.host + global.posturl.videoChange, {
          video_id: video_id,
          state: 0,
        })
        .then(function (response) {
          console.log(response.data);
          var qcode = response.data.code;
          if (qcode == 200) {
            thi.getstart();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //格式化时间
    formatDate(date) {
      if (!date) {
        return "无";
      }
      Date.prototype.toLocaleString = function () {
        return (
          this.getFullYear() +
          "年" +
          (this.getMonth() + 1) +
          "月" +
          this.getDate() +
          "日" +
          this.getHours() +
          "点" +
          this.getMinutes() +
          "分" +
          this.getSeconds() +
          "秒"
        );
      };
      var unixTimestamp = new Date(date * 1000);
      return unixTimestamp.toLocaleString();
    },
    //状态改变（启用）
    changeArticleState(video_id, state) {
      //方法传进来的，不用this.
      let thi = this;
      thi.fullscreenLoading = true;
      this.$http
        .post(global.posturl.host + global.posturl.videoChange, {
          video_id: video_id,
          state: state,
        })
        .then(function (response) {
          var qcode = response.data.code;
          if (qcode == 200) {
            thi.getstart();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //状态改变（启用）
    changeArticleState1(row) {
      let thi = this;
      console.log(row);
      // return
      axios
        .get(
          "http://api.txcsok.com/Video/videoChangeAll?state=" +
            row +
            "&theme_id=" +
            1,
          {}
        )
        .then((data) => {
          thi.getstart();
        });
    },
  },
};
</script>

<style scoped>
.admin-body {
  /*background-color: white;*/
  width: 100%;
}

.main {
  background-color: white;
  min-height: 500px;
  padding: 10px;
  border: #ededed 1px solid;
  border-radius: 5px;
}

.block {
  text-align: left;
}

.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/video/VideoTheme.vue